// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"1bcda8ed","358":"75baa353","657":"70059a3b","972":"3a5bc1eb","984":"90841717"}[chunkId] + ".chunk.js";
};